import React, { Fragment, useState, useEffect } from 'react'
import imgs from '../../utils/images';
import axios from "axios";
import { base_url } from '../../actions/constants';
import { useParams, Link } from "react-router-dom";
import Navbar from './Navbar';

const EmailVerified = () => {
    const [validUrl, setValidUrl] = useState(true);
    const param = useParams();

    useEffect(() => {
        axios.defaults.baseURL = base_url;

        const verifyEmailUrl = async () => {
            try {
                const { data } = await axios.get(`/api/users/${param.id}/verify/${param.token}`);
                setValidUrl(true);
            } catch (error) {
                setValidUrl(false);
            }
        };
        verifyEmailUrl();
    }, [param]);
    return (
        <Fragment>
            <div className='registration py-5'>
                <div className='mt-5'>
                    {validUrl ? (
                        <div className='p-5 text-center'>
                            <img src={imgs.email_verified} alt='icon_thumb' />
                            <h2 className='py-4'>Your email address has been verified</h2>
                            <p className='px-5 mb-3'>Your Booqy account is not active. Please use the link below to login to your account.</p>
                            <Link to='/login' className="btn btn-custom mt-3 shadow mb-5">Login to Booqy</Link>
                        </div>
                    ) : (
                        <div className='text-center my-5'>
                            <h2>404 Page Not Found</h2>
                        </div>
                    )}
                </div>
            </div>
        </Fragment>
    )
}

export default EmailVerified